import { formatNumber } from '../../logic';
import * as S from './style';

interface GrassCountProps {
  totalContributionData?: number;
}

export function GrassCount({ totalContributionData }: GrassCountProps) {
  return (
    <>
      <S.Wrapper>
        <S.TextWrapper>
          <S.Text>누적 잔디수</S.Text>
          <S.GrassCountText>
            {formatNumber(totalContributionData)} 개
          </S.GrassCountText>
        </S.TextWrapper>
        <S.TextWrapper>
          <S.Text>목표 잔디수</S.Text>
          <S.GrassCountText>200,000 개</S.GrassCountText>
        </S.TextWrapper>
      </S.Wrapper>
    </>
  );
}
